import CloseIcon from '@mui/icons-material/Close';
import {Box, IconButton, Typography} from '@mui/material';

import {greenColors} from '../../../../../../layouts/theme/designSystem';

interface ModalHeaderProps {
  title: string;
  handleClose(): void;
}

export const ModalHeader = ({title, handleClose}: ModalHeaderProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        alignContent: 'center',
        alignItems: 'center',
        mb: 2,
      }}
    >
      <Typography variant='h2'>{title}</Typography>
      <Box display={'flex'} justifyContent={'flex-end'}>
        <IconButton onClick={handleClose}>
          <CloseIcon
            sx={{
              color: greenColors[700],
              fontSize: '30px',
            }}
          />
        </IconButton>
      </Box>
    </Box>
  );
};
